import React, { useState, useContext, useEffect } from "react";
import Footer from "../../components/footer/main";
// import Navbar from "../../components/Navbar/Navbar";
import MdEditor from "react-markdown-editor-lite";
import MarkdownIt from "markdown-it";
// import showdown from "showdown";
import { Link } from "react-router-dom";
import Axios from "axios";
import readingTime from "reading-time";
import { apiURL } from "../../keys";

const MOCK_DATA = "Hey write on the left\n\n * This is markdown.\n * remove me before writing";

const Writefn = () => {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [category, setCategory] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState("");
  const [draft, setDraft] = useState("false");

  const [blogpost, setBlogpost] = useState("");

  let mdParser = new MarkdownIt();

  useEffect(() => {}, []);

  const submit = (e) => {
    e.preventDefault();
    // console.log(title);
    // console.log(subtitle);
    // console.log(category);
    // console.log(email);
    // console.log(password);
    // console.log(blogpost);
    const blogObj = {
      title,
      subContent: subtitle,
      content: blogpost,
      writer: "Rupansh",
      image,
    };
    if (draft == "true") {
      blogObj.draft = true;
    } else {
      blogObj.draft = false;
    }
    blogObj.readBy = 0;
    blogObj.readTime = 3;
    blogObj.readTime = Math.round(readingTime(blogpost).minutes);
    let categories = category.split(",");
    blogObj.category = categories;
    blogObj.slug = title.split(" ").join("-");

    Axios.post(`${apiURL}/blogs/create`, blogObj)
      .then((data) => {
        alert("successfully uploaded");
      })
      .catch((err) => {
        alert("error try again.");
      });
    console.log(blogObj);
  };

  const handlechange = (e, editor) => {
    const data = editor.getData();
    setBlogpost(data);
  };

  const handleEditorChange = ({ html, text }) => {
    // console.log("handleEditorChange", html);
    setBlogpost(html);
  };

  return (
    <div className="updiv">
      <div className="container">
        <br />
        <Link to="/">
          <button type="button" class="btn btn-light">
            Go Back
          </button>
        </Link>

        <h1>
          Write your
          <br />{" "}
          <b>
            <span className="tgreen">POST</span>
          </b>
        </h1>
        <br />
        <br />

        <MdEditor
          value={MOCK_DATA}
          renderHTML={(text) => mdParser.render(text)}
          onChange={handleEditorChange}
        />
        <br />
      </div>
      <div className="text-center mb-4" style={{ marginTop: "0.1rem" }}>
        <div className="container">
          <input
            type="text"
            className="form-control mb_10"
            placeholder="TITLE"
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb_10"
            placeholder="Sub title"
            onChange={(e) => setSubtitle(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb_10"
            placeholder="Categories(seperated with comma) eg tax,gst."
            onChange={(e) => setCategory(e.target.value)}
          />
          <input
            type="text"
            className="form-control mb_10"
            placeholder="Header Image URL"
            onChange={(e) => setImage(e.target.value)}
          />
          <input
            type="email"
            className="form-control mb_10"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            className="form-control mb_10"
            id="exampleInputPassword1"
            placeholder="password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <select
            className="form-control"
            id="exampleFormControlSelect1"
            onChange={(e) => setDraft(e.target.value)}
          >
            <option selected>Set as draft?</option>
            <option value={true}>Yes</option>
            <option value={false}>No</option>
          </select>
        </div>
        <button className="btn btn-dark mt-2 " style={{ width: "25vh" }} onClick={submit}>
          Submit
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default Writefn;
